import React, { useState } from "react";
import { useApp } from "context";
import { Helpers, Routes } from "utils";
import { Box, Grid, Typography } from "@mui/material";
import { Card, Custom, Info, Modal } from "components";
import { IClinic, IProvider, IService } from "interfaces";

type Props = {};

export const Home = (props: Props) => {
  const { t, theme, user } = useApp();

  const [clinic, setClinic] = useState<IClinic>({} as IClinic);
  const [service, setService] = useState<IService>({} as IService);
  const [provider, setProvider] = useState<IProvider>({} as IProvider);
  const [reminderOpened, setReminderOpened] = useState(false);
  const [appointmentOpened, setAppointmentOpened] = useState(false);
  const [clinicOpened, setClinicOpened] = useState(false);
  const [providerOpened, setProviderOpened] = useState(false);
  const [serviceOpened, setServiceOpened] = useState(false);
  const [countAppointments, setCountAppointments] = useState(0);
  // TODO: it may be improved (currently being used to force the updated of the appointments)
  const [incrementComponentAppointment, setIncrementComponentAppointment] =
    useState(0);
  const [incrementComponentProvider, setIncrementComponentProvider] =
    useState(0);

  // TODO: reset the clinic and the provider when the appointment is cancelled or created

  const handleAppointmentOpen = (service: IService) => {
    setService(service);
    setServiceOpened(false);
    setAppointmentOpened(true);
  };

  const handleAppointmentClose = (updated: boolean) => {
    updated &&
      setIncrementComponentAppointment(incrementComponentAppointment + 1);
    setAppointmentOpened(false);
  };

  const handleAppointmentChange = (countAppointments: number) =>
    setCountAppointments(countAppointments);

  const handleClinicOpen = () => setClinicOpened(true);
  const handleClinicClose = () => setClinicOpened(false);

  const handleProviderOpen = () => setProviderOpened(true);

  const handleProviderClose = () => {
    setIncrementComponentProvider(incrementComponentProvider + 1);
    setProviderOpened(false);
  };

  const handleReminderOpen = () => setReminderOpened(true);
  const handleReminderClose = () => setReminderOpened(false);

  const handleServiceOpen = () => {
    setAppointmentOpened(false);
    setServiceOpened(true);
  };

  const handleServiceClose = () => {
    setClinic({} as IClinic);
    setServiceOpened(false);
  };

  const handleScheduleClinic = (clinic: IClinic) => {
    setClinic(clinic);
    handleServiceOpen();
  };

  const handleScheduleProvider = (provider: IProvider) => {
    setProvider(provider);
    handleServiceOpen();
  };

  // TODO: too primitive
  const stripePaymentURL = "https://buy.stripe.com/dR65om39S7jE5Q46os";

  return (
    <>
      <div className="qh-header">
        <Grid container spacing={theme.margin.md}>
          <Grid container item xs={12} sm={6}>
            <div className="qh-title">
              <Typography component="span" sx={{ fontSize: theme.font.md }}>
                {Helpers.interpolate(t.message.greeting[Helpers.greeting()], {
                  username: user.username,
                })}
              </Typography>
            </div>
          </Grid>
          <Grid container item xs={12} sm={6} justifyContent="flex-end">
            <Box
              className="qh-control"
              display="inline-flex"
              gap={theme.margin.md}
            >
              <Custom.Button
                onClick={() => window.open(stripePaymentURL, "_blank")}
              >
                {t.action.make_payment}
              </Custom.Button>
              {/* <Custom.Button variant="outlined" href={Routes.patient.journey}>
                {t.action.view_all}
              </Custom.Button> */}
              <Custom.Button onClick={handleServiceOpen}>
                {t.action.make_appointment}
              </Custom.Button>
              <Modal.MakeAppointment
                clinic={clinic}
                service={service}
                provider={provider}
                opened={appointmentOpened}
                onBack={handleServiceOpen}
                onClose={handleAppointmentClose}
              />
            </Box>
          </Grid>
        </Grid>
      </div>
      <div className="qh-content">
        <Grid container spacing={theme.margin.md}>
          <Grid item xs={12}>
            <Grid container spacing={theme.margin.md}>
              <Grid item xs={12}>
                <Grid container spacing={theme.margin.md}>
                  <Grid item xs={12}>
                    <Info.Announcement />
                  </Grid>
                  <Grid item xs={12}>
                    <Info.WeekAppointment
                      incrementComponent={incrementComponentAppointment}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Card.QubePlus />
          </Grid>
          <Grid item xs={12}>
            <Card.Service
              opened={serviceOpened}
              clinicId={clinic?.clinicId}
              onOpen={handleServiceOpen}
              onClose={handleServiceClose}
              onClick={(service: IService) => handleAppointmentOpen(service)}
            />
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={theme.margin.md}>
              <Grid item xs={12} sm={6} md={3}>
                <Card.Clinic
                  opened={clinicOpened}
                  onOpen={handleClinicOpen}
                  onClose={handleClinicClose}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card.Provider
                  opened={providerOpened}
                  onOpen={handleProviderOpen}
                  onClose={handleProviderClose}
                  incrementComponent={incrementComponentProvider}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card.Reminder
                  opened={reminderOpened}
                  onOpen={handleReminderOpen}
                  onClose={handleReminderClose}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card.Journey
                  incrementComponent={incrementComponentAppointment}
                  onChange={handleAppointmentChange}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
